import ArrowDownIcon from "@/public/icons/arrow-down.svg";
import {Field} from "formik";
import SelectInput from "@/components/UI/Form/Selects/SelectInput/SelectInput";
import ErrorMessage from "@/components/UI/Form/ErrorMessage/ErrorMessage";

const Select = ({
    options,
    name,
    onChange,
    onSearch,
    showSearch,
    placeholder,
    modifyOptions = (options) => options,
    suffixIcon = <ArrowDownIcon/>,
    mode= null,
    label = null,
    hideError = false,
    autoSelectSingleOption,
    autoSelectFirstOption,
    ...props
}) => {
    options ??= []

    return (
        <Field name={name ?? label}>
            {
                ({field, form, meta}) => {
                    return <div style={{width: '100%'}}>
                        <SelectInput
                            disabled={props.disabled || false}
                            {...props}
                            {...field}
                            label={label}
                            mode={mode}
                            selected={field.value}
                            placeholder={placeholder}
                            options={modifyOptions(options, field.value)}
                            autoSelectSingleOption={autoSelectSingleOption}
                            autoSelectFirstOption={autoSelectFirstOption}
                            suffixIcon={suffixIcon}
                            showSearch={showSearch}
                            onSearch={onSearch}
                            onChange={(value) => {
                                form.setFieldValue(field.name, value);
                                onChange?.(value)
                            }}
                        />
                        {!hideError && <ErrorMessage meta={meta} />}
                    </div>
            }}
        </Field>
    );
};

export default Select;
